import { reviews } from "@/mocks/product";

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <svg
          key={star}
          className={`w-4 h-4 ${star <= rating ? "text-amber-500 fill-amber-500" : "text-stone-300"}`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ))}
    </div>
  );
}

export default function ReviewsSection() {
  return (
    <section id="reviews" className="w-full bg-[#faf9f7] py-20 md:py-28">
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <div className="flex items-center justify-center gap-2 mb-4">
              <span className="w-2 h-2 rounded-full bg-amber-400" />
              <span className="text-xs font-medium text-stone-500 tracking-wider uppercase">
                Customer Reviews
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-semibold text-stone-900">
              Cat Parents
              <br className="md:hidden" />
              Love It
            </h2>
            <p className="mt-3 text-sm md:text-base text-stone-500">
              Real experiences from Costco shoppers
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {reviews.map((review, index) => (
              <div
                key={review.id}
                className={`bg-white rounded-2xl p-6 md:p-7 border border-stone-100 ${
                  index >= 4 ? "opacity-70" : ""
                }`}
              >
                <StarRating rating={review.rating} />
                <h3 className="mt-3 text-base font-semibold text-stone-900">
                  {review.title}
                </h3>
                <p className="mt-2 text-sm text-stone-600 leading-relaxed line-clamp-4">
                  {review.content}
                </p>
                <div className="mt-5 flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-stone-200 flex items-center justify-center text-xs font-semibold text-stone-600">
                    {review.avatar}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-stone-900">
                      {review.user}
                    </p>
                    <p className="text-xs text-stone-400">{review.pet}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}